<template src="./Settings.html">
</template>

<script>
import Vue from 'vue'
import { SettingsService } from '../../services/SettingService';
import { validationMixin } from 'vuelidate';
import { required, between } from 'vuelidate/lib/validators';

export default {
  name: 'settings',
  mixins: [ validationMixin ],

  data: () => ({
    settingsService: new SettingsService(),

    measure_interval: 0,
    water_below: 0,
    light_below: 0,
    red_amount: 0,
    blue_amount: 0,
    heat_below: 0,
    fan_above: 0,

    errorMsg: '',
    isLoading: false,
  }),


  validations: {
    measure_interval: { required, between: between( 0, 1000 ) },
    water_below: { required, between: between( 0, 100 ) },
    light_below: { required, between: between( 0, 100 ) },
    red_amount: { required, between: between( 0, 100 ) },
    blue_amount: { required, between: between( 0, 100 ) },
    heat_below: { required, between: between( -30, 100 ) },
    fan_above: { required, between: between( -30, 100 ) },
  },

  created() {
    this.settingsService.getAllSettings()
    .then(
      ( response ) => {
        this.measure_interval = response.data['MEASURE_INTERVAL']
        this.water_below = response.data['WATER_BELOW']
        this.light_below = response.data['LIGHT_BELOW']
        this.red_amount = response.data['RED_AMOUNT']
        this.blue_amount = response.data['BLUE_AMOUNT']
        this.heat_below = response.data['HEAT_BELOW']
        this.fan_above = response.data['FAN_ABOVE']
      },
      ( err ) => {
        this.errorMsg = 'Klaida! Nepavyko gauti nustatymų iš serverio. Bandykite dar kartą.'
      }
    );
  },

  methods: {
    saveSettings() {
      this.errorMsg = ''
      this.isLoading = true

      this.settingsService.setAllSettings(
        {
          settings: [
            { name: 'MEASURE_INTERVAL', value: this.measure_interval },
            { name: 'WATER_BELOW', value: this.water_below },
            { name: 'LIGHT_BELOW', value: this.light_below },
            { name: 'RED_AMOUNT', value: this.red_amount },
            { name: 'BLUE_AMOUNT', value: this.blue_amount },
            { name: 'HEAT_BELOW', value: this.heat_below },
            { name: 'FAN_ABOVE', value: this.fan_above },
          ]
        }
      )
      .then( 
        (  ) => this.$router.push({ name: 'home' }),
        ( err ) => this.errorMsg = 'Klaida: nepavyko išsaugoti nustatymų. Bandykite dar kartą.',
        () => this.isLoading = false
      );
    }
  }

}
</script>

<style lang="scss" scoped>
label {
    margin-bottom: 0rem;
}
</style>


